import { render } from "./syarat-berperkara.vue?vue&type=template&id=234047e3&scoped=true"
import script from "./syarat-berperkara.vue?vue&type=script&lang=js"
export * from "./syarat-berperkara.vue?vue&type=script&lang=js"

import "./syarat-berperkara.vue?vue&type=style&index=0&id=234047e3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-234047e3"

export default script